module.exports = __webpack_public_path__ + "static/media/new_person_3.90d1e1b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/new_person_3.jpg
// module id = 1912
// module chunks = 0